import { render, staticRenderFns } from "./PredicateEditor.vue?vue&type=template&id=710f665c&scoped=true"
import script from "./PredicateEditor.vue?vue&type=script&lang=js"
export * from "./PredicateEditor.vue?vue&type=script&lang=js"
import style0 from "./PredicateEditor.vue?vue&type=style&index=0&id=710f665c&prod&lang=scss"
import style1 from "./PredicateEditor.vue?vue&type=style&index=1&id=710f665c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710f665c",
  null
  
)

export default component.exports